module.exports = __webpack_public_path__ + "img/report.fd1b761e.png";